import type { UpdateNotificationReadStatus200BasicInfo } from './updateNotificationReadStatus200BasicInfo';
import type { UpdateNotificationReadStatus200Data } from './updateNotificationReadStatus200Data';
import type { UpdateNotificationReadStatus200Source } from './updateNotificationReadStatus200Source';
import type { UpdateNotificationReadStatus200Status } from './updateNotificationReadStatus200Status';
import type { UpdateNotificationReadStatus200Target } from './updateNotificationReadStatus200Target';

/**
 * 알림 응답 데이터
 */
export type UpdateNotificationReadStatus200 = {
  basicInfo?: UpdateNotificationReadStatus200BasicInfo;
  /** 알림 추가 데이터 (유형에 따라 다름) */
  data?: UpdateNotificationReadStatus200Data;
  /** 알림 소스 정보 */
  source?: UpdateNotificationReadStatus200Source;
  /** 알림 상태 정보 */
  status?: UpdateNotificationReadStatus200Status;
  /** 알림 대상 정보 */
  target?: UpdateNotificationReadStatus200Target;
};
